export const SET_STEP = 'SET_STEP'
export const SET_VISITED_STEP = 'SET_VISITED_STEP'
export const RESET_VISITED_STEP = 'RESET_VISITED_STEP'
export const SET_RECOMMENDATIONS = 'SET_RECOMMENDATIONS'
export const SET_RECOMMENDATION = 'SET_RECOMMENDATION'
export const RESET_RECOMMENDATION = 'RESET_RECOMMENDATION'
export const SET_CRITERIA_CHANGED = 'SET_CRITERIA_CHANGED'
export const PREP_RECOMMENDATION = 'PREP_RECOMMENDATION'
export const RESET_TRANSLATIONS = 'RESET_TRANSLATIONS'
export const SET_TRANSLATIONS = 'SET_TRANSLATIONS'
export const RESET_RESULTTYPE = 'RESET_RESULTTYPE'
export const SET_RESULTTYPE = 'SET_RESULTTYPE'
export const SET_RESULTTYPES = 'SET_RESULTTYPES'
export const UPDATE_RESULTTYPE = 'UPDATE_RESULTTYPE'
export const SET_ADAS_EXCLUSIONS = 'SET_ADAS_EXCLUSIONS'
export const SET_ADAS_MATRICES = 'SET_ADAS_MATRICES'
export const INIT_ADAS_MATRIX = 'INIT_ADAS_MATRIX'
export const UPDATE_ADAS_MATRIX = 'UPDATE_ADAS_MATRIX'
export const UPDATE_ADAS_MATRIXITEM = 'UPDATE_ADAS_MATRIXITEM'
export const SET_ADAS_MATRIX = 'SET_ADAS_MATRIX'
export const SET_DECODED_VIN = 'SET_DECODED_VIN'
export const SET_DECODED_ALT_VIN = 'SET_DECODED_ALT_VIN'
export const INIT_ADAS_MAKE_MATRIX = 'INIT_ADAS_MAKE_MATRIX'
export const SET_ADAS_MAKE_MATRICES = 'SET_ADAS_MAKE_MATRICES'
export const SET_ADAS_MAKE_MATRIX = 'SET_ADAS_MAKE_MATRIX'
export const UPDATE_ADAS_MAKE_MATRIX = 'UPDATE_ADAS_MAKE_MATRIX'
export const SET_ADAS_MAKE_MATRIX_ID = 'SET_ADAS_MAKE_MATRIX_ID'
export const SET_ADAS_MATRIX_INFO_LOOKUPS = 'SET_ADAS_MATRIX_INFO_LOOKUPS'
export const SET_ADAS_MATRIX_INFO_LOOKUP = 'SET_ADAS_MATRIX_INFO_LOOKUP'
export const SET_ADAS_MATRIX_INFO_ID = 'SET_ADAS_MATRIX_INFO_ID'
export const INIT_ADAS_MATRIX_INFO_LOOKUP = 'INIT_ADAS_MATRIX_INFO_LOOKUP'
export const UPDATE_ADAS_MATRIX_INFO_LOOKUP = 'UPDATE_ADAS_MATRIX_INFO_LOOKUP'

export const SESSION_ADAS_MATRIX = 'SESSION_ADAS_MATRIX'



// WEBPACK FOOTER //
// ./src/store/modules/admin/configuration/types.js